function scrollTo(section) {
    if (section === "response") {
        // Remove loading animation
        document.querySelector('.loading-validator').classList.remove('d-block');
        // Go to validated result
        const targetPosition = document.querySelector("#validator-response").getBoundingClientRect().top + window.scrollY - 76;
        window.scroll({ top: targetPosition, behavior: 'smooth' });
    } else if (section === "top") {
        window.scroll({ top: 0, behavior: 'smooth' });
    }
}

var VM = function () {
    var self = this;
    self.working = ko.observable(false);
    self.showResult = ko.observable(false);
    self.jwtToken = ko.observable("");
    self.jwtHeader = ko.observable(null);
    self.jwtPayload = ko.observable(null);
    self.error = ko.observable(null);
    self.status = ko.observable(null);
    self.tableView = ko.observable(false);
    self.headerTable = ko.observableArray([]);
    self.payloadTable = ko.observableArray([]);
    self.signatureVerified = ko.observable(null);
    self.jwtSignature = ko.observable("");

    self.explanation = {
        // Header
        alg: "The algorithm used to sign the JWT (e.g., HS256, RS256).",
        typ: "The media type of this complete JWT.",
        kid: "Key ID: A hint indicating which key was used to secure the token.",
        
        // Payload (Registered Claims)
        iss: "Issuer: Identifies the principal that issued the JWT.",
        sub: "Subject: Identifies the principal that is the subject of the JWT (e.g., User ID).",
        aud: "Audience: Identifies the recipients that the JWT is intended for.",
        exp: "Expiration Time: The time on or after which the JWT must not be accepted for processing, represented as a Unix timestamp.",
        nbf: "Not Before: The time before which the JWT must not be accepted for processing, represented as a Unix timestamp.",
        iat: "Issued At: The time at which the JWT was issued, represented as a Unix timestamp.",
        jti: "JWT ID: A unique identifier for the token, used to prevent replay attacks.",
        
        // Common Public / Private Claims
        name: "Full name of the user.",
        email: "Email address of the user.",
        admin: "Boolean flag indicating if the user has administrative privileges.",
        roles: "List of roles or permissions assigned to the user.",
        auth_time: "Time when the user authentication occurred, represented as a Unix timestamp."
    };

    self.exampleJwtToken = function() {
        self.jwtToken("eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiYWRtaW4iOnRydWUsImlhdCI6MTUxNjIzOTAyMn0.KMUFsIDTnFmyG3nMiGM6H9FNFUROf3wh7SmqJp-QV30");
    }

    self.addTableData = function(jsonData, targetObservable) {
        var mappedArray = Object.keys(jsonData).map(function(key) {
            return {
                key: key,
                value: jsonData[key]
            };
        });
        
        targetObservable(mappedArray);
    };

    self.formatDate = function(unixTimestamp) {
        if (!unixTimestamp) return '';
        var date = new Date(Number(unixTimestamp) * 1000);
        return date.toString(); 
    };

    self.now = ko.observable(Math.floor(Date.now() / 1000));

    setInterval(function() {
        self.now(Math.floor(Date.now() / 1000));
    }, 1000);

    self.getCountdown = function(expValue) {
        return ko.computed(function() {
            var diff = Number(expValue) - self.now();
            if (diff <= 0) return "Expired";
            
            var d = Math.floor(diff / 86400);
            var h = Math.floor((diff % 86400) / 3600);
            var m = Math.floor((diff % 3600) / 60);
            var s = diff % 60;
            
            var parts = [];
            if (d > 0) parts.push(d + "<small>d</small>");
            if (h > 0 || d > 0) parts.push(h + "<small>h</small>");
            parts.push(m + "<small>m</small>");
            parts.push(s + "<small>s</small>");
            
            return parts.join(" ");
        });
    };

    self.decode = function() {
        // reset values
        self.showResult(false);
        self.working(true);
        self.jwtHeader(null);
        self.jwtPayload(null);
        self.error(null);
        self.status(null);
        self.tableView(false);
        self.headerTable([]);
        self.payloadTable([]);
        self.signatureVerified(null);
        self.jwtSignature("");

        var token = self.jwtToken().trim();
        if (token.split('.').length !== 3) {
            self.working(false);
            self.showResult(true);
            self.status('Invalid Token');
            self.error('JWT must have 3 parts separated by dots.');
            scrollTo('response');
            return;
        }

        try {
            // Header
            const header = jwt_decode(token, { header: true });
            self.jwtHeader(JSON.stringify(header, null, 2));
            self.addTableData(header, self.headerTable);

            // Payload
            const payload = jwt_decode(token);
            self.jwtPayload(JSON.stringify(payload, null, 2));
            self.addTableData(payload, self.payloadTable);

            setTimeout(function() {
                self.working(false);
                self.showResult(true);
                const cardGuidCode = document.querySelector('.card-guid-code');
                cardGuidCode.querySelectorAll('pre code.hljs').forEach((block) => {
                    hljs.highlightBlock(block);
                });
                scrollTo('response');
            }, 500);
        } catch (e) {
            self.working(false);
            self.showResult(true);
            self.status('Decoding error');
            self.error('The token content is not a valid Base64 string.');
            scrollTo('response');
        }
    }

    self.checkSignature = function() {
        document.querySelector('#jwtSignature').classList.remove('is-invalid');
        
        if (self.jwtSignature() === "") {
            document.querySelector('#jwtSignature').classList.add('is-invalid');
        } else {
            verifyJWT(self.jwtToken(), self.jwtSignature()).then(isValid => {
                if (isValid) {
                    self.signatureVerified(true);
                } else {
                    self.signatureVerified(false);
                }

                scrollTo('response');
            });
        }
    }

    // Copy to clipboard button
    const copyCode = new ClipboardJS('.cpybutton', {
        target: function (evt) {
            return evt.closest('.form-group').querySelector('pre code');
        }
    });
    copyCode.on('success', function(evt) {
        evt.clearSelection();
        const cpyButton = new bootstrap.Tooltip(evt.trigger);
        cpyButton.show();
        setTimeout(() => cpyButton.hide(), 1000);
    });

    // Copy as code
    const copyAsCode = new ClipboardJS('.cpyascodebutton', {
        text: function (trigger) {
            return `using System.IdentityModel.Tokens.Jwt;

var token = "${self.jwtToken()}";
var handler = new JwtSecurityTokenHandler();

if (handler.CanReadToken(token))
{
    var jwtToken = handler.ReadJwtToken(token);
    
    // Accessing common claims
    Console.WriteLine($"Subject: {jwtToken.Subject}");
    Console.WriteLine($"Issuer: {jwtToken.Issuer}");
    
    foreach (var claim in jwtToken.Claims)
    {
        Console.WriteLine($"{claim.Type}: {claim.Value}");
    }
}`
        }
    });
    copyAsCode.on('success', function(evt) {
        evt.clearSelection();
        const cpyButton = new bootstrap.Tooltip(evt.trigger);
        cpyButton.show();
        setTimeout(() => cpyButton.hide(), 1000);
    });

    function verifyJWT(token, secret) {
        const [headerB64, payloadB64, signatureB64] = token.split('.');
        const encoder = new TextEncoder();
        const data = encoder.encode(`${headerB64}.${payloadB64}`);
        const signature = base64UrlToBytes(signatureB64);

        // Returnăm direct promisiunea
        return window.crypto.subtle.importKey(
            "raw",
            encoder.encode(secret),
            { name: "HMAC", hash: "SHA-256" },
            false,
            ["verify"]
        ).then(key => {
            return window.crypto.subtle.verify("HMAC", key, signature, data);
        });
    }

    function base64UrlToBytes(base64url) {
        const base64 = base64url.replace(/-/g, '+').replace(/_/g, '/');
        const binStr = atob(base64);
        const bytes = new Uint8Array(binStr.length);
        for (let i = 0; i < binStr.length; i++) {
            bytes[i] = binStr.charCodeAt(i);
        }
        return bytes.buffer;
    }

    self.shareToolbox = ko.pureComputed({
        read: function () {
            var url = encodeURIComponent(window.location.href),
                title = encodeURIComponent(document.title),
                description = encodeURIComponent(document.getElementsByName('description')[0].getAttribute('content'));
            
            return { 
                facebook: 'https://www.facebook.com/sharer.php?u=' + url,
                twitter: 'https://x.com/intent/tweet?url=' + url + '&text=' + title,
                linkedin: 'https://www.linkedin.com/sharing/share-offsite/?url=' + url,
                email: 'mailto:?subject=' + title + '&body=' + description + ' Link: ' + url
            };
        },
        owner: this
    });
}

document.addEventListener("DOMContentLoaded", function () {
    var vm = new VM();
    ko.applyBindings(vm, document.body);

    // Hljs more description
    const moreDescription = document.querySelector('.more-description');
    moreDescription.querySelectorAll('pre code').forEach((block) => {
        hljs.highlightBlock(block);
    });
});